/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';

export type CaloricBreakdown = {
  percentProtein: number;
  percentFat: number;
  percentCarbs: number;
};

export function createCaloricBreakdown(json?: Partial<CaloricBreakdown>): CaloricBreakdown {
  return makeAutoObservable({
    percentProtein: json?.percentProtein ?? 0,
    percentFat: json?.percentFat ?? 0,
    percentCarbs: json?.percentCarbs ?? 0,
  });
}
